import Section from "./Section";
import Services from "./Services";
import Product from "./Product";
import Skills from "./Skills";

function Page() {
  return (
    <>
      <Section />
      <Skills />
      <Services />
      <Product />
    </>
  );
}
export default Page;
